module.exports = __webpack_public_path__ + "img/travel-2.8ef8be8d.jpeg";